export default __webpack_public_path__ + "static/media/tvv.146767dd.jpg";